'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (path, body, callback) {
  var config = (0, _config.getConfig)();
  var req = new XMLHttpRequest();

  req.open('GET', '' + config.host + path);
  req.setRequestHeader('Content-Type', 'application/json');
  req.setRequestHeader('X-Api-Key', config.apiKey);

  if (body && body.token) {
    req.setRequestHeader('X-Bifrost-Authorization', body.token);
  } else {
    var cookieToken = (0, _utils.getCookie)('Valgrind-AU');
    if (cookieToken != null && cookieToken !== '') {
      req.setRequestHeader('X-Bifrost-Authorization', cookieToken);
    }
  }

  if (config.applicationId) {
    req.setRequestHeader('X-ECS-APPLICATION-ID', config.applicationId);
  }

  req.withCredentials = true;

  req.onreadystatechange = function () {
    if (req.readyState < 4) {
      return;
    }

    callback(req.status < 200 || req.status > 299, {
      status: req.status,
      responseText: req.responseText,
      response: (0, _utils.parseJSON)(req.responseText)
    });
  };

  req.send();
};

var _utils = require('./utils');

var _config = require('./config');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/bifrost/build/request.js
// module id = 70
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38